import * as React from 'react';
export const citibankSvg = React.forwardRef(function citibankSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M13.43 22.282h1.962v-9.575H13.43v9.575Zm3.756-7.762h1.645v5.4c0 .744.204 1.339.595 1.794.39.465.92.698 1.58.716.66.019 1.236-.13 1.729-.437l.028-.018v-.028l.464-1.822-.111.074c-.52.316-1.004.474-1.45.474-.604 0-.92-.362-.92-1.078V14.52h1.998v-1.794h-1.998V9.733l-1.924 1.032v1.961h-1.646l.01 1.794Zm7.491 7.762h1.971v-9.575h-1.97v9.575Zm-12.371-8.069-.047-.028c-.901-1.096-2.026-1.636-3.383-1.636-1.357 0-2.584.437-3.514 1.293-.994.91-1.487 2.128-1.487 3.662 0 1.534.502 2.742 1.487 3.662.92.864 2.1 1.283 3.514 1.283 1.413 0 2.49-.54 3.383-1.618l.047-.027-1.106-1.339-.047.047c-.716.715-1.487 1.078-2.324 1.078-.836 0-1.58-.298-2.147-.874-.576-.576-.846-1.31-.846-2.203 0-.892.27-1.636.846-2.222.567-.566 1.283-.864 2.147-.864.865 0 1.599.372 2.324 1.078l.046.047 1.107-1.339Z',
      fill: '#00387D',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M14.397 11.137a8.207 8.207 0 0 1 2.612-1.813 7.49 7.49 0 0 1 2.993-.604c1.04 0 2.045.195 3.002.604a8.34 8.34 0 0 1 2.593 1.813l.028.027h2.25l-.084-.13a9.522 9.522 0 0 0-3.43-2.965A9.33 9.33 0 0 0 20.001 7a9.366 9.366 0 0 0-4.368 1.07 9.704 9.704 0 0 0-3.43 2.964l-.093.13h2.26l.018-.027h.009Z',
      fill: '#E60A17',
    }),
  );
});
citibankSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var citibank = {
  category: 'brand',
  colorable: false,
  name: 'citibank',
  svg: citibankSvg,
};
